export default function Oferta() {
  return (
    <section id="oferta" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block bg-yellow-400 text-purple-900 px-4 py-2 rounded-full text-sm font-bold mb-6">
            Oferta Especial
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Está na hora de transformar seu negócio
          </h2>
          <p className="text-xl text-gray-600">
            Invista no seu futuro com condições especiais
          </p>
        </div>
        
        <div className="bg-gradient-to-br from-purple-900 to-purple-800 rounded-3xl p-10 lg:p-14 shadow-2xl">
          <div className="text-center mb-10">
            <p className="text-purple-200 text-lg mb-4">De R$ 549,99 por apenas</p>
            <div className="flex items-center justify-center gap-4 mb-2">
              <span className="text-yellow-400 text-2xl">12x de</span>
              <span className="text-6xl md:text-7xl font-bold text-white">R$ 25,86</span>
            </div>
            <p className="text-purple-200 text-lg">ou R$ 249,99 à vista</p>
          </div>
          
          <div className="text-center">
            <a
              href="https://pay.kiwify.com.br/gZuAA7n"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-yellow-400 text-purple-900 px-12 py-6 rounded-full text-xl font-bold hover:bg-yellow-500 transition-all transform hover:scale-105 shadow-2xl cursor-pointer inline-flex items-center gap-3 mb-6 whitespace-nowrap"
            >
              Quero garantir minha vaga agora
              <i className="ri-arrow-right-line text-2xl"></i>
            </a>
            
            <div className="flex flex-wrap items-center justify-center gap-6 text-purple-100 text-sm">
              <div className="flex items-center gap-2">
                <i className="ri-lock-line text-yellow-400"></i>
                <span>Pagamento 100% seguro</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
